import { Row, Col } from "react-bootstrap";

const ContactUs = () => {
  const text = (
    <div>
      <p>
        <b>Contact Us</b>
      </p>
      <p>
        For queries in relation to the end-of-waste register or specific
        registrations please email{" "}
        <a href="mailto: article28@epa.ie">article28@epa.ie</a> .
      </p>
      <p>
        Further information and guidance in relation to end-of-waste and
        registration is available at&nbsp;
        <a
          style={{ fontWeight: "bold" }}
          href="https://www.epa.ie/our-services/licensing/waste/end-of-waste-art-28/"
        >
          https://www.epa.ie/our-services/licensing/waste/end-of-waste-art-28/.
        </a>
      </p>
    </div>
  );

  return (
    <Row>
      <Col className="ps-4">{text}</Col>
    </Row>
  );
};

export default ContactUs;
